<ng-diagram-node-resize-adornment>
  <div
    class="group-node"
    ngDiagramGroupHighlighted
    ngDiagramNodeSelected
    [attr.data-content-id]="node()?.data?.figure.id"
    [attr.data-node-id]="node()?.id"
    [attr.data-node-type]="'figure'"
    [node]="node()"
  >
    <ng-diagram-port id="port-right" side="right" style="top: 30px" type="source" />

    <div class="group-node__header">
      <mat-icon class="ddc-content-icon">{{ icon() }}</mat-icon>
      <span class="group-node__title">{{ title() }}</span>
    </div>
    <div class="group-node__content">
      <span class="content-title">{{ node()?.data?.figure.title }}</span>
      @if (figurePicUrl()) {
        <img class="content-thumbnail" [alt]="node()?.data?.figure.title" [src]="figurePicUrl()" />
      }
    </div>
  </div>
</ng-diagram-node-resize-adornment>
